export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/grey-next.32e9ed9a.svg","height":13,"width":14,"blurWidth":0,"blurHeight":0};